import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHeadphones = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M2.75 11.75h1.3c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874c.218.428.218.988.218 2.108V16c0 .232 0 .348-.01.446a2 2 0 0 1-1.794 1.794c-.098.01-.214.01-.446.01s-.348 0-.446-.01a2 2 0 0 1-1.794-1.794c-.01-.098-.01-.214-.01-.446v-4.25Zm0 0V9a7.25 7.25 0 0 1 14.5 0v2.75m0 0h-1.3c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874c-.218.428-.218.988-.218 2.108V16c0 .232 0 .348.01.446a2 2 0 0 0 1.794 1.794c.098.01.214.01.446.01s.348 0 .446-.01a2 2 0 0 0 1.794-1.794c.01-.098.01-.214.01-.446v-4.25Z"
	})]
});
const ForwardRef = forwardRef(SvgHeadphones);
export { ForwardRef as ReactComponent };
